<template>
	<div>
    <b-container>
      <b-alert show variant="primary" class="px-2 py-2 mt-2">
        <b-row class="m-0 align-items-center">
          <b-col cols="1" class="p-0">
            <i class="material-icons align-middle">history</i>
          </b-col>
          <b-col cols="8" class="p-0">
            <span class="small">Previous time spent on this task</span>
          </b-col>
          <b-col cols="3" class="p-0">
            <span class="font-weight-bolder">{{transformSeconds}}</span>
          </b-col>
        </b-row>
      </b-alert>
      <div class="text-center">
        <p class="h4 font-weight-bold text-blue-dark">{{Title}}</p>
        <p class="h6 text-muted">{{ProjectName}}</p>
        <b-button v-b-modal="'modal-scrollable'+type" size="sm" class="mb-3 outline-main">
          <i class="material-icons align-middle">assignment</i>
          Task Detail
        </b-button>
      </div>

      <b-modal :id="'modal-scrollable'+type" scrollable ok-only hide-header>
        <task-detail :showButtons="false"></task-detail>
      </b-modal>

    </b-container>
	</div>
</template>

<script>
  import { mapGetters } from "vuex"
  export default {
    props:{
      taskId:{
        required:true,
        type:Number
      },
      Title:{
        required:true,
        type:String
      },
      ProjectName:{
        required:false,
        type:String
      },
      type:{
        required:true,
        type:String
      }
    },
    computed:{
      ...mapGetters('timer',['getTaskSpentTime']),
      transformSeconds(){
        let seconds = this.getTaskSpentTime(this.taskId)
        let hours=0
        let minutes=0
        if(seconds>60){
          minutes=Math.floor(seconds/60)
          seconds=seconds%60
        }
        if(minutes>60){
          hours=Math.floor(minutes/60)
          minutes=minutes%60
        }
        if (seconds<10){
          seconds='0'+seconds
        }
        if (minutes<10){
          minutes='0'+minutes
        }
        if (hours<10){
          hours='0'+hours
        }
        return hours+":"+minutes+":"+seconds
      }

    }
  }
</script>
